import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useCountries } from '@app/countries';
import { BsContext } from '@app/transaction';
import { Region, Country } from '@app/types';

import { getTheCountries } from '@app/redux/localization/selectors';
import { getCountryCode } from '@app/redux/clientLocale/selectors';

const useGetRegions = () => {
  const countries: Country[] = useSelector(getTheCountries);
  const countryCode: Region['code'] = useSelector(getCountryCode);

  const { topCountries, allCountries, countriesLoading } = useCountries(
    BsContext.Buy,
    'sneakers',
  );

  const countryOptions = useMemo(
    () => topCountries?.concat(allCountries || []),
    [topCountries, allCountries],
  );

  const regionOptions = useMemo(
    () =>
      countryOptions?.map((country, index) => ({
        display: country.name,
        value: country.id,
        key: index,
      })),
    [countryOptions],
  );

  // preferredCurrency is not available in countryOptions
  const regions = useMemo(
    () =>
      countries.map((country) => ({
        id: country.id,
        display: country.name,
        value: country.iso2,
        preferredCurrency: country.preferredCurrency,
      })),
    [countries],
  );

  // Default Region is based on customer location
  const defaultRegion = regions.find(({ value }) => value === countryCode);

  return {
    regions,
    regionOptions,
    regionsLoading: countriesLoading,
    defaultRegion,
  };
};

export default useGetRegions;
